import { Button } from "@/components/ui/button";
import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField";
import { brDateHourFormat } from "../../../../common/helpers/date.helpers";
import { useSupplierDashboardContext } from "./useSupplierDashboardContext";
import { ModalViewLogs } from "@/modules/logsDetails/logsDetails.modal";
import { useState } from "react";

function SupplierInfo() {
  const { supplier } = useSupplierDashboardContext();
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  return (
    <>
      <section className="col-span-1 lg:col-span-3 dark:text-black bg-gray/20 rounded p-3">
        <h2 className="font-semibold text-2xl mb-4">
          Informações do Fornecedor
        </h2>
        <section className="grid grid-cols-2 gap-2 mb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 text-sm lg:text-lg col-span-3 gap-2 ">
            <GenericInfoField
              id={1}
              spanSize={"col-span-2"}
              label={"Razão social"}
              value={supplier.companyName}
            />
            <GenericInfoField
              id={2}
              spanSize={"col-span-2"}
              label={"Nome fantasia"}
              value={supplier.tradingName}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"E-mail"}
              value={supplier.supplierEmail}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"CNPJ ou CPF"}
              value={supplier.cnpj}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"Nome do contato comercial"}
              value={supplier.workContact.name}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"Telefone comercial"}
              value={supplier.workContact.phone}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"Nome do contato operacional"}
              value={supplier.operationalContact.name}
            />
            <GenericInfoField
              id={3}
              spanSize={"col-span-1"}
              label={"Telefone operacional"}
              value={supplier.operationalContact.phone}
            />
          </div>
          <section>
            <div className="w-full dark:text-black bg-gray/40 rounded mb-4 p-3">
              <h2 className="font-semibold text-2xl mb-4">Observações</h2>
            </div>
            <div>
              {supplier.observations.map((info, index) => {
                return (
                  <div
                    key={index}
                    className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40"
                  >
                    <label className="font-semibold">
                      {brDateHourFormat(info.date)}
                    </label>
                    <p className="whitespace-pre-wrap">
                      <h3 className="font-semibold">Observação:</h3>
                      {info.text}
                    </p>
                    <br />
                    <p className="font-semibold">Criado por: {info.author}</p>
                  </div>
                );
              })}
            </div>
          </section>
        </section>
        <div className="div-tabs-border-line"></div>
        <section className="tabs-item-style">
          <div className="max-w-7xl mx-auto ">
            <Button
              variant="destructive"
              className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0`}
              onClick={() => setIsLogModalOpen(true)}
            >
              Visualizar Logs
            </Button>
          </div>
        </section>
      </section>
      {isLogModalOpen && supplier._id && (
        <ModalViewLogs
          onClose={() => setIsLogModalOpen(false)}
          entity="suppliers" // Entidade fixa como solicitado
          entityId={supplier._id} // ID do veículo do contexto
        />
      )}
    </>
  );
}
export default SupplierInfo;
